module.exports = __webpack_public_path__ + "img/save-video.a6e060fe.webp";